<div class="modal-header">
  <h3>{{ existingSignedDocument ? 'Edit' : 'Upload' }} Signed Documents</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <div class="row mb-3">
    <div class="col">
      <h6 class="mb-2">Vendor Agreement</h6>
      <app-file-upload-file-display
        [removeFileButtonText]="'Remove'"
        [hideSelectFileButton]="true"
        [Files]="VendorAgreementFile ? [VendorAgreementFile] : []"
        [layout]="'vertical'"
        [fileInfoDisplayType]="'minimal'"
        (FileEvent)="vendorAgreementFileUpload($any($event))"
        (removeFileEvent)="removeVendorAgreementFile($any($event))"
      ></app-file-upload-file-display>
    </div>
  </div>

  <!-- W9 Section -->
  <div class="row">
    <div class="col">
      <h6 class="mb-2">W9 Document</h6>
      <app-file-upload-file-display
        [removeFileButtonText]="'Remove'"
        [hideSelectFileButton]="true"
        [Files]="W9File ? [W9File] : []"
        [layout]="'vertical'"
        [fileInfoDisplayType]="'minimal'"
        (FileEvent)="w9FileUpload($any($event))"
        (removeFileEvent)="removeW9File($any($event))"
      ></app-file-upload-file-display>
    </div>
  </div>
  @if (isAdminUser() && !existingSignedDocument && isW9OnlyUpload()) {
    <div class="row mt-3">
      <div class="col">
        <div class="form-check d-flex align-items-center gap-2">
          <input
            id="allClients"
            type="checkbox"
            class="form-check-input m-0"
            [(ngModel)]="allVendorClients"
            (change)="onAllVendorClientsChange()"
          />
          <label for="allClients" class="form-check-label m-0"
            >Upload for all clients?</label
          >
        </div>
      </div>
    </div>
  }
</div>
<div class="modal-footer mt-3">
  <div class="col-2">
    <button type="button" class="btn btn-danger h-100" (click)="close()">
      Close
    </button>
  </div>
  <div class="col-2">
    <button type="button" class="btn btn-primary h-100" (click)="upload()">
      {{ existingSignedDocument ? 'Update' : 'Upload' }}
    </button>
  </div>
</div>
